"use strict";

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(toss);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toss = void 0;

var pure_rand_1 = require("pure-rand");

var Random_1 = require("../../random/generator/Random");

var PureRandom_1 = require("../../random/generator/PureRandom");

var NextValue_1 = require("../arbitrary/definition/NextValue");

function lazyGenerate(generator, rng, idx) {
  return function () {
    return generator.generate(new Random_1.Random(rng), idx);
  };
}

function toss(generator, seed, random, examples) {
  var idx, rng;
  return _regeneratorRuntime.wrap(function toss$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.delegateYield(examples.map(function (e) {
            return function () {
              return new NextValue_1.NextValue(e, undefined);
            };
          }), "t0", 1);

        case 1:
          idx = 0;
          rng = (0, PureRandom_1.convertToRandomGenerator)(random(seed));

        case 3:
          rng = rng.jump ? rng.jump() : (0, pure_rand_1.skipN)(rng, 42);
          _context.next = 6;
          return lazyGenerate(generator, rng, idx++);

        case 6:
          _context.next = 3;
          break;

        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

exports.toss = toss;